// extracted by mini-css-extract-plugin
export default {"idle":"Idle-module__idle--_WWNO","copilotRun":"Idle-module__copilotRun--y4Bix"};